// extracted by mini-css-extract-plugin
export default {"container":"ProfileSection_container__m7x2J","sectionTitle":"ProfileSection_sectionTitle__-M08E"};